import React from 'react';
import AppLayout from '../../../layouts/app/AppLayout';
import '../custom.scss';

import { translateThis } from '../../../helpers/language.helper';
import AppIcons from '../../../assets/images/icons';

import SVGIcons from '../../../assets/images/icons/svgIcons';




const HerClubDetailPage = () => {
    // custom home functions here
    const pageName = "Projects";

    const forVolunteerCon = [
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Empower volunteers to make a positive impact on menstrual hygiene education and accessibility for girls in Africa and Asia.',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Ensure programs are affordable, inclusive, and accessible to people of all ages and from all backgrounds.',
        },
        {
            icon: <SVGIcons.CircularTick />,
            title: 'Provide training to volunteers on menstrual hygiene education and sustainable practices, and train local teams on best practices in volunteer management.',
        },
    ];

    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper project-detail-wrapper f-wrp">
                <div className='main-container-wrp'>
                    <div className='project-detail-blk f-wrp'>
                        <div className='each-proj-detail-box f-wrp'>
                            <h1>{translateThis("what")} <b>{translateThis("we do")}</b></h1>
                            <p>{translateThis("Her Club by Dolly, an initiative under the World Development Programme, is dedicated to improving menstrual hygiene and awareness for girls in Africa and Asia. The program addresses the critical issue of menstrual hygiene by providing access to affordable, biodegradable sanitary pads and conducting educational workshops in schools. These workshops teach girls about menstrual hygiene and how to make their own reusable sanitary products.")}</p>
                            <p>{translateThis("Founded by H.E. Vishnou Toolcanon, Chairman and Ambassador of WDP-Kenya, Her Club operates with the goal of ensuring every girl experiences safe, hygienic, and dignified menstrual periods without fear of embarrassment. Through outreach programs, the organization educates girls about the importance of menstrual hygiene, helping to reduce school dropouts and improve academic performance during their menstrual cycles. Her Club also partners with various government ministries and non-governmental organizations to expand its reach and effectiveness. The initiative aims to provide 2 million school-going girls with sanitary napkins and menstrual hygiene education across the region, with plans to produce 9,000 sanitary napkins per day from its machines. By promoting proper menstrual hygiene practices, Her Club empowers girls, enhances their self-esteem, and contributes to their overall health and well-being.")}</p>
                            <p>{translateThis('As part of the World Development Programme, Her Club is aligned with the mission of achieving global development goals and United Nations sustainable development goals. The broader aim is to empower nations affected by poverty, diseases, illiteracy, and human rights abuses through innovative solutions in education, health, and sustainable development, with a particular focus on Kenya.')}</p>
                        </div>
                        <div className='each-proj-detail-box f-wrp'>
                            <h1>{translateThis("About")} <b>{translateThis("us")}</b></h1>
                            <p>{translateThis("Her Club by Dolly, an initiative under the World Development Programme, is committed to addressing the menstrual hygiene needs of girls in Africa and Asia. Founded by H.E. Vishnou Toolcanon, the initiative seeks to provide affordable")}</p>
                        </div>
                        <div className='for-volunteer-box f-wrp'>
                            <div className='for-volunteer-con'>
                                <h1>{translateThis('For volunteers')}</h1>
                                <ul>
                                    {forVolunteerCon.map((element, key) => (
                                        <li key={key}>
                                            <span className='impact-icon'>{element.icon}</span>
                                            <p>{translateThis((element.title))}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className='for-volunteer-img'>
                                <span><img src={AppIcons.forVolunteer} alt='For volunteers' /></span>
                            </div>
                        </div>


                    </div>
                </div>

            </div>
        </AppLayout>
    )
}

export default HerClubDetailPage;